export enum FEATURE_TOGGLE {
  CASEMAN_V3 = 'CASEMAN_V3',
}
